import { Helmet } from "react-helmet-async";
import { useTitle } from "../helper/functions";
import { pageTitle } from "../helper/globals";

export default function TnC() {
  useTitle("Terms and Conditions" + pageTitle);

  return (
    <div className="bg-light-50 px-6 py-32 lg:px-8">
      <Helmet>
        <meta
          name="description"
          content="MSB Motor description."
        />
        <meta name="robots" content="noindex,nofollow"></meta>
      </Helmet>
      <div className="mx-auto max-w-3xl text-base leading-7 text-dark-700">
        <h1 className="mt-2 text-base font-light uppercase tracking-tight text-dark-900">
          Terms and Conditions
        </h1>
        <div className="mt-4 max-w-2xl text-xs font-light leading-relaxed">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
        </div>
      </div>
    </div>
  );
}
